import { CircleAIAppShell } from "@circle-react-uikit/CircleAIAppShell";

import { t } from "@/i18n-js/instance";

import { DockBodyContent } from "./DockBodyContent";
import { DockFooterContent } from "./DockFooterContent";

interface DesktopDockProps {
  hidden: boolean;
  isAdmin: boolean;
  isCircleAiEnabled: boolean;
  isDockNavEnabled: boolean;
  isPromoLockedToPlansPage: boolean;
}

export const DesktopDock = ({
  hidden,
  isAdmin,
  isCircleAiEnabled,
  isDockNavEnabled,
  isPromoLockedToPlansPage,
}: DesktopDockProps) => (
  <CircleAIAppShell.Layout.Dock
    aria-label={t("circle_ai_shell.dock")}
    hidden={hidden}
  >
    <CircleAIAppShell.Layout.Dock.Header>
      {!isDockNavEnabled && isAdmin && isCircleAiEnabled && (
        <div className="flex flex-col items-center gap-2 p-3">
          <CircleAIAppShell.ConversationPanelToggleButton />
        </div>
      )}
    </CircleAIAppShell.Layout.Dock.Header>
    <CircleAIAppShell.Layout.Dock.Body>
      <DockBodyContent />
    </CircleAIAppShell.Layout.Dock.Body>
    {!isPromoLockedToPlansPage && (
      <CircleAIAppShell.Layout.Dock.Footer>
        <DockFooterContent />
      </CircleAIAppShell.Layout.Dock.Footer>
    )}
  </CircleAIAppShell.Layout.Dock>
);
